import { createIcon } from '../create-icon'

// Crossed swords — aggressive, proactive plays
export const GpiAggression = createIcon('GpiAggression', ({ strokeWidth }) => (
  <>
    <path d="M14.5 17.5 3 6V3h3l11.5 11.5" strokeWidth={strokeWidth} />
    <path d="M13 19l6-6" strokeWidth={strokeWidth} />
    <path d="M16 16 2 2" strokeWidth={strokeWidth} />
    <path d="M9.5 6.5 3 6V3h3l.5 3.5" strokeWidth={strokeWidth} />
    <path d="m21 3-5.5 5.5" strokeWidth={strokeWidth} />
    <path d="M21 3h-3l-11.5 11.5" strokeWidth={strokeWidth} />
    <path d="M21 3v3" strokeWidth={strokeWidth} />
  </>
))
